module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0747c_banner_800x600.0f1c70a6.png";